export default __webpack_public_path__ + "static/media/icon_policy_overview_summary.5a5634bb.svg";